import React from 'react'
import AnimatedLogo from '@wellbeingxltd/fe-lib/images/dist/logo/AnimatedLogo.gif'
import styles from './styles.module.scss'

/**
 * Used: Directory/Product, Directory/ShopifyProducts
 */
export const ToggleButton = ({ disabled, id, label, loading, onChange, checked }) => (
    <div className={styles.ToggleButton}>
        <div className={styles.inputBlock}>
            {loading ? (
                <div className={styles.loaderBlock}>
                    <img src={AnimatedLogo} alt="Loading spinner" />
                </div>
            ) : (
                <input {...{ checked, className: styles.input, id, onChange }} type="checkbox" disabled={disabled || loading} />
            )}
        </div>
        <label htmlFor={id}>{label}</label>
    </div>
)
